import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { contentGenerationContextToolSchema } from "../content-generation-context-tool/content-generation-context-tool-definition";
import {
  marketingAgentPromptPopulatedSchema,
  marketingAgentPromptSchema,
} from "../marketing/marketing-agent-prompt/marketing-agent-prompt-definition";

// @deprecated Use triggerMarketingAgentPromptId instead
export enum ContentGenerationTrigger {
  CART_ABANDONMENT = "cart-abandonment",
  BROWSE_ABANDONMENT = "browse-abandonment",
  CHECKOUT_ABANDONMENT = "checkout-abandonment",
}

export enum ContentGenerationTargetType {
  SMS_CONTENT = "sms-content",
}

const smsContentTargetSchema = z.object({
  type: z.literal(ContentGenerationTargetType.SMS_CONTENT),
  params: z.object({ partsLimit: z.number() }),
});

const contentGenerationTargetSchema_ = z.discriminatedUnion("type", [
  smsContentTargetSchema,
]);
export const contentGenerationTargetSchema: z.ZodType<ContentGenerationTarget> =
  contentGenerationTargetSchema_;
export type ContentGenerationTarget = z.infer<
  typeof contentGenerationTargetSchema_
>;

const contentGeneratorConfigVersionSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  triggerMarketingAgentPromptId: zExt.objectId(),
  target: contentGenerationTargetSchema_,
  strategyMarketingAgentPromptId: zExt.objectId().optional(),
  initialScenarioMarketingAgentPromptIds: z.array(zExt.objectId()).optional(),
  publishedAt: z.date().optional(),
  contextTools: z.array(contentGenerationContextToolSchema),
  customInstructions: z.string().optional(),
  // @deprecated Examples are sourced from AI Context Library or MarketingAgentPrompt.
  examples: z.array(z.string()).optional(),
  // @deprecated Examples are sourced from AI Context Library or MarketingAgentPrompt.
  recoverExamples: z.array(z.string()).optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const contentGeneratorConfigVersionSchema =
  contentGeneratorConfigVersionSchema_;
export type ContentGeneratorConfigVersion = z.infer<
  typeof contentGeneratorConfigVersionSchema_
>;

// Populated schema (with populated marketing agent prompts including goals and methods)
export const contentGeneratorConfigVersionPopulatedSchema =
  contentGeneratorConfigVersionSchema_
    .omit({
      triggerMarketingAgentPromptId: true,
      strategyMarketingAgentPromptId: true,
    })
    .extend({
      triggerMarketingAgentPrompt: marketingAgentPromptSchema.optional(),
      strategyMarketingAgentPrompt:
        marketingAgentPromptPopulatedSchema.optional(),
      contextTools: z.array(contentGenerationContextToolSchema).default([]),
    });

export type ContentGeneratorConfigVersionPopulated = z.infer<
  typeof contentGeneratorConfigVersionPopulatedSchema
>;
